export default {
    feedList(state) {
        for (const index in state.feedList) {
            state.feedList[index] = { 
                ...state.feedList[index], 
                mainCatOptions: [], 
                subCatOptions: [], 
                detailCatOptions: []
            }
        }
        
        return state.feedList;
    },
    mainCategory(state) {
        return state.feedCategory?.mainCategory;
    },
    subCategory(state, _, _2, rootGetters) {
        const hierarchyState = rootGetters.isHierarchic;

        if (hierarchyState) {
            const mainCatId = state.hierarchicMainCatId;

            if (mainCatId) return state.feedCategory.subCategory.filter(x => x.parentId == parseInt(mainCatId));
            
            return [];
        }
        
        return state.feedCategory?.subCategory || [];
    },
    detailCategory(state, _, _2, rootGetters) {
        const hierarchyState = rootGetters.isHierarchic;

        if (hierarchyState) {
            const subCatId = state.hierarchicSubCatId;

            if (subCatId) return state.feedCategory.detailCategory.filter(x => x.parentId == parseInt(subCatId));
            
            return [];
        }

        return state.feedCategory?.detailCategory || [];
    },
    feedCategory(state){
        return state.feedCategory;
    }
}